<ng-container *ngrxLet="isLoading$; let isLoading">
    <div class="modal-header" id="equipments-list-modal-title">
        <h3 class="modal-title" id="modal-title" translate="SELECT_EQUIPMENT_TITLE"></h3>
        <span class="close" (click)="modalInstance.hide()">&times;</span>
    </div>
    <ng-container *ngrxLet="equipmentsList$; let equipmentsList">
        <div class="modal-body" id="modal-body">
            <div class="row">
                <div class="col-12">
                    <!-- Table for md and up -->
                    <div class="table-responsive d-none d-md-block">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th translate="SELECT_EQUIPMENT_MATERIAL_NUMBER_TITLE"></th>
                                    <th translate="SELECT_EQUIPMENT_DESCRIPTION_TITLE"></th>
                                    <th translate="SELECT_EQUIPMENT_SERIAL_NUMBER_TITLE"></th>
                                    <th translate="SELECT_EQUIPMENT_COUNTRY_TITLE"></th>
                                    <th translate="SELECT_EQUIPMENT_LOCATION_TITLE"></th>
                                </tr>
                            </thead>
                            <tbody>
                                @if (!isLoading && equipmentsList.length > 0) {
                                    @for (equipment of equipmentsList; track equipment) {
                                        <tr (click)="openForms(equipment)" class="clickable">
                                            <td>{{ equipment.PartNo }}</td>
                                            <td>{{ equipment.Description }}</td>
                                            <td>{{ equipment.SerialNo }}</td>
                                            <td>{{ equipment.Country || equipment.HcCountry }}</td>
                                            <td>{{ equipment.Location }}</td>
                                        </tr>
                                    }
                                }

                                @if (!isLoading && equipmentsList.length === 0) {
                                    <tr>
                                        <td colspan="5">
                                            <div
                                                class="text-center"
                                                translate="SELECT_EQUIPMENT_NO_EQUIPMENT_AVAILABLE"
                                            ></div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <!-- list for small screens -->
                    <div class="d-block d-md-none">
                        @if (!isLoading && equipmentsList.length > 0) {
                            @for (equipment of equipmentsList; track equipment) {
                                <div
                                    class="list-group-item list-group-item-action border-bottom clickable mb-3 border-2"
                                    (click)="openForms(equipment)"
                                >
                                    <div class="mb-1 col-12">
                                        <span class="fw-semibold me-1" aria-hidden="true">
                                            {{ 'SELECT_EQUIPMENT_MATERIAL_NUMBER_TITLE' | translate }}:
                                        </span>
                                        <span>{{ equipment.PartNo }}</span>
                                    </div>
                                    <div class="mb-1 col-12">
                                        <span class="fw-semibold me-1" aria-hidden="true">
                                            {{ 'SELECT_EQUIPMENT_SERIAL_NUMBER_TITLE' | translate }}:
                                        </span>
                                        <span>{{ equipment.SerialNo }}</span>
                                    </div>
                                    <div class="mb-1 col-12">
                                        <span class="fw-semibold me-1" aria-hidden="true">
                                            {{ 'SELECT_EQUIPMENT_DESCRIPTION_TITLE' | translate }}:
                                        </span>
                                        <span>{{ equipment.Description }}</span>
                                    </div>
                                    <div class="mb-1 col-12">
                                        <span class="fw-semibold me-1" aria-hidden="true">
                                            {{ 'SELECT_EQUIPMENT_COUNTRY_TITLE' | translate }}:
                                        </span>
                                        <span>{{ equipment.Country || equipment.HcCountry }}</span>
                                    </div>
                                    <div class="col-12 mb-3">
                                        <span class="fw-semibold me-1" aria-hidden="true">
                                            {{ 'SELECT_EQUIPMENT_LOCATION_TITLE' | translate }}:
                                        </span>
                                        <span>{{ equipment.Location }}</span>
                                    </div>
                                </div>
                            }
                        } @else {
                            <div class="text-center py-3" translate="SELECT_EQUIPMENT_NO_EQUIPMENT_AVAILABLE"></div>
                        }
                    </div>

                    <!-- Loading bar small screen -->
                    @if (isLoading) {
                        <div class="text-center my-3">
                            <progressbar [striped]="true"></progressbar>
                        </div>
                    }
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <!-- Loading bar for big screen -->
            <div class="d-none d-md-block">
                @if (isLoading) {
                    <progressbar [striped]="true"></progressbar>
                }
            </div>
            <div>
                <button
                    type="button"
                    class="btn btn-primary"
                    (click)="modalInstance.hide()"
                    translate="SELECT_EQUIPMENT_BUTTON_CANCEL"
                ></button>
            </div>
        </div>
    </ng-container>
</ng-container>
